export const PAYMENT_TYPES_DEFAULT = {
  braintree: 0,
  paypal: 1,
  onAccount: 3,
};

export const PAYMENT_TYPES_CCC = {
  ...PAYMENT_TYPES_DEFAULT,
  voucher: 4,
  applePay: 5,
  googlePay: 6,
};

Object.freeze(PAYMENT_TYPES_CCC);

export const PAYMENT_TYPES_SEALINK = {
  ...PAYMENT_TYPES_DEFAULT,
  savedCard: 4,
  applePay: 5,
  googlePay: 6,
};

export const CheckoutDialogStatesEnum = {
  closed: 0,
  paymentPending: 1,
  error: 2,
  paymentSuccess: 3,
  printingBoardingPass: 4,
  boardingPassPrinted: 5,
};

Object.freeze(CheckoutDialogStatesEnum);

export const SPECIAL_EVENT_PRODUCT_KEY = 'Special Event';

export const OPTIONAL_EXTRA_PRODUCT_TYPE_MAPPING = {
  cccwa: 22,
  whitsundays: 7,
};

export const HIGH_VOLUME_IMPORT_VEHICLE = 'HIGH_VOLUME_IMPORT_VEHICLE';

export const IS_ONE_SEALINK = window.ecom?.craftConfig?.tenant === 'sealink';

export const SEGMENT_TYPE = {
  pickup: 'pickup',
  dropoff: 'dropoff',
  primary: 'primary',
};

export const SERVICE_FORM_BOOKING_STATUS = {
  loading: 'loading',
  normal: 'normal',
  saving: 'saving',
  submitting: 'submitting',
  only_departure_submitting: 'only_departure_submitting',
};

export const ALL_SUBROUTE_VALUE = 'all_route';

export const FIRST_VEHICLE_FORM_KEY = 'first_vehicle_form';
